export const cleanId = (id) => {
  if (!id) return null;
  if (typeof id === "string" && id.includes("No.")) {
    return parseInt(id.replace("No.", "").trim(), 10);
  }
  const n = parseInt(id, 10);
  return Number.isNaN(n) ? null : n;
};

export const buildRatingChatMessage = ({
  item,
  order,
  scores,
  direction = "driver_to_customer",
}) => {
  const fromRaw =
    item?.booking_from ??
    order?.transport?.booking_from ??
    item?.transport?.booking_from ??
    null;
  const toRaw =
    item?.booking_to ??
    order?.transport?.booking_to ??
    item?.transport?.booking_to ??
    null;

  const from = Array.isArray(fromRaw) ? fromRaw[0] : fromRaw;
  const to = Array.isArray(toRaw) ? toRaw[0] : toRaw;

  const orderNo =
    order?.order_id ||
    order?.transport?.booking_id ||
    (order?.id ? `Nr.${String(order.id).padStart(6, "0")}` : null) ||
    "—";

  const bookingNo =
    item?.booking_id ||
    item?.transport?.booking_id ||
    order?.transport?.booking_id ||
    (item?.transport?.id
      ? `Nr.${String(item.transport.id).padStart(6, "0")}`
      : null) ||
    (item?.id ? `Nr.${String(item.id).padStart(6, "0")}` : null) ||
    "—";

  const avg =
    scores.average ??
    (
      (Number(scores.punctuality || 0) +
        Number(scores.communication || 0) +
        Number(scores.cargo_care || 0) +
        Number(scores.rating || 0)) /
      4
    ).toFixed(1);

  const payload = {
    type: "rating_card",
    direction,
    status: "completed",
    from: from || "N/A",
    to: to || "N/A",
    booking_id: bookingNo,
    order_id: orderNo,
    punctuality: scores.punctuality,
    communication: scores.communication,
    cargo_care: scores.cargo_care,
    rating: scores.rating,
    average: Number(avg),
    comment: scores.comment || null,
  };

  return `__RATING_CARD__${JSON.stringify(payload)}`;
};

export const sendRatingChatMessage = async ({
  apiSendMessage,
  transportId,
  orderId,
  item,
  order,
  scores,
  direction = "driver_to_customer",
}) => {
  const cleanTransportId = cleanId(transportId);
  const cleanOrderId = cleanId(orderId);

  if (!cleanTransportId || !cleanOrderId) {
    console.warn("⚠️ Missing IDs for rating chat message", {
      transportId,
      orderId,
    });
    return;
  }

  try {
    const formData = new FormData();
    formData.append(
      "message",
      buildRatingChatMessage({ item, order, scores, direction }),
    );

    const result = await apiSendMessage(
      cleanTransportId,
      cleanOrderId,
      formData,
    );

    if (!result?.success) {
      console.error("❌ Rating chat message failed:", result?.message);
    }
  } catch (error) {
    console.error("❌ Error sending rating chat message:", error);
  }
};